<!--
 * @Author: your name
 * @Date: 2021-07-27 20:30:08
 * @LastEditTime: 2022-05-24 14:46:53
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\exclusivePurchase\index.vue
-->
<template>
  <div class="exclusive-wrapper">
    <div class="exclusive-content">
      <el-card class="box-card">
        <slot></slot>
        <div class="box-card-content">
          <div class="box-card-title flex-sb">
            <p class="title">
              {{ activeType == 1 ? '' : '4.' }}平台商品资源配置
            </p>
            <p v-if="activeType != 1">
              <i class="icon-circle" v-if="check1 == 1"></i>
              <i
                class="el-icon-circle-check icon-success"
                v-if="check1 == 2"
              ></i>
              <i class="el-icon-circle-close icon-error" v-if="check1 == 3"></i>
            </p>
          </div>
          <div class="box-card-desc margin-b20">
            您可以选择易派客平台中感兴趣的供应商和商品品类，展示在贵企业的采购专属商城。
          </div>

          <!-- step1 -->
          <div>
            <div class="collocation-box flex-sb">
              <div class="collocation-box-left">
                <p class="collocation-box-text">供应商名称：</p>
                <div class="flex">
                  <el-input
                    @keyup.enter.native="search(1)"
                    v-model="querySupplier.companyName"
                    suffix-icon="el-icon-search"
                    style="width: 220px; margin-right: 10px"
                    placeholder="输入关键字进行过滤"
                  ></el-input>
                  <el-button @click="reset(1)">重 置</el-button>
                  <el-button @click="search(1)" type="primary" plain
                    >查 询</el-button
                  >
                </div>
                <div class="collocation-data scrollbar_content">
                  <el-table
                    v-loading="leftTableloading"
                    height="320px"
                    :data="allSupplierList"
                    border
                    style="width: 100%"
                    ref="leftTableData"
                    @selection-change="leftSelectionChange"
                  >
                    <el-table-column
                      type="selection"
                      width="50"
                    ></el-table-column>
                    <el-table-column prop="companyName" label="供应商名称">
                      <template slot-scope="scope">
                        <el-popover
                          placement="top-start"
                          title="供应商名称:"
                          width="300"
                          trigger="hover"
                        >
                          <div>{{ scope.row.companyName }}</div>
                          <span slot="reference">{{
                            scope.row.companyName.substr(0, 20) + '...' + ''
                          }}</span>
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column prop="businessScope" label="经营范围">
                      <template slot-scope="scope">
                        <el-popover
                          placement="top-start"
                          title="经营范围:"
                          width="300"
                          trigger="hover"
                        >
                          <div>{{ scope.row.businessScope }}</div>
                          <span slot="reference">{{
                            scope.row.businessScope
                              ? scope.row.businessScope.substr(0, 20) +
                                '...' +
                                ''
                              : ''
                          }}</span>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="collocation-box-middle" v-if="!hasPurchaseCategory">
                <div>
                  <el-button
                    class="width80"
                    @click="transferTable(1)"
                    type="primary"
                    plain
                    :disabled="
                      leftMultipleSelection.length == 0 || hasPurchaseCategory
                    "
                    >添加<i class="el-icon-arrow-right el-icon--right"></i
                  ></el-button>
                </div>
                <div>
                  <el-button
                    class="width80"
                    @click="transferTable(2)"
                    type="primary"
                    plain
                    :disabled="rightMultipleSelection.length == 0"
                    icon="el-icon-arrow-left"
                    >取消</el-button
                  >
                </div>
              </div>
              <div class="collocation-box-right" v-if="!hasPurchaseCategory">
                <p class="collocation-box-text">已选择：</p>
                <div class="flex">
                  <el-input
                    @keyup.enter.native="search(2)"
                    v-model="searchValue2"
                    suffix-icon="el-icon-search"
                    style="width: 220px; margin-right: 10px"
                    placeholder="输入关键字进行过滤"
                  ></el-input>
                  <el-button @click="reset(2)">重 置</el-button>
                  <el-button @click="search(2)" type="primary" plain
                    >查 询</el-button
                  >
                </div>
                <div class="collocation-data scrollbar_content">
                  <el-table
                    v-loading="rightTableloading"
                    :data="rightTableData"
                    border
                    style="width: 100%"
                    ref="rightTableData"
                    @selection-change="rightSelectionChange"
                  >
                    <el-table-column
                      type="selection"
                      width="50"
                    ></el-table-column>
                    <el-table-column
                      prop="supplierCompanyName"
                      label="供应商名称"
                    ></el-table-column>
                    <el-table-column label="操作" width="100" align="center">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="selectCategory(scope.row)"
                          >选择商品分类</el-button
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="companyName"
                      label="状态"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.type == 1"
                          >已选择</el-tag
                        >
                        <el-tag type="danger" v-else>未选择</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="collocation-box-right" v-if="hasPurchaseCategory">
                <p class="collocation-box-text">已选择的商品分类：</p>

                <div class="collocation-data scrollbar_content">
                  <el-tree
                    :data="purchaseCategoryList"
                    :props="purchaseDefaultProps"
                  ></el-tree>
                </div>
              </div>
            </div>
            <div class="collocation-btn">
              <el-button
                v-if="!hasPurchaseCategory"
                type="primary"
                plain
                @click="submitData"
                >保 存</el-button
              >
              <el-button
                v-else
                type="primary"
                plain
                @click="hasPurchaseCategory = false"
                >编 辑</el-button
              >
            </div>
          </div>
          <!-- step1 -->
          <el-dialog
            :title="dialogTitle"
            :visible.sync="categoryDialog"
            :modal-append-to-body="false"
            width="700px"
          >
            <div v-loading="dialogloading">
              <div class="flex-c" style="margin-bottom: 20px">
                <el-transfer
                  filterable
                  v-model="selectedCategory"
                  :props="defaultProps"
                  :data="categoryList"
                  :titles="['全部分类', '已选分类']"
                ></el-transfer>
              </div>
              <div slot="footer" class="dialog-footer flex-c">
                <el-button @click="categoryDialog = false">取 消</el-button>
                <el-button type="primary" @click="upDataCategory()"
                  >确 定</el-button
                >
              </div>
            </div>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import cmsOssApi from '../../api/cms-oss/index';
import productApi from '../../api/product/index';
import userApi from '../../api/agreement/index';
// import TreeTransfer from 'el-tree-transfer'
export default {
  props: {
    activeType: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    // TreeTransfer,
  },

  computed: {
    ea_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    ea_userInfo: {
      immediate: true,
      handler(val) {
        if (val.companyId) {
          this.userInfo = this.$store.state.USERINFO;

          this.querySupplierListByPurchaserId(val.companyId);
          this.purchaseAreaCategory();
        }
      },
      deep: true,
    },
  },

  created() {
    // this.userInfo=this.$store.state.USERINFO;

    this.querySupplierList();
  },
  data() {
    return {
      userInfo: '',
      check1: 1,
      activeStep: 1,

      // leftTableData: [],
      rightTableData: [],
      leftMultipleSelection: [],
      rightMultipleSelection: [],
      resourceAllocationIsok: false,

      searchValue1: '',
      searchValue2: '',
      allLeftTableData: '',
      allRightTableData: '',

      querySupplier: {
        companyName: '',
        pageNum: 1,
        pageSize: 10,
      }, // 查询供应商

      allSupplierList: [],
      leftTableloading: false,
      rightTableloading: false,
      categoryList: [],
      dialogTitle: '',
      categoryDialog: false,
      selectedCategory: [],
      defaultProps: {
        key: 'categoryId',
        label: 'categoryName',
      },
      purchaseInfo: {}, //供应商信息
      dialogloading: false,
      hasPurchaseCategory: false, //是否生成小类
      purchaseCategoryList: [], //已生成的小类
      purchaseDefaultProps: {
        children: 'children',
        label: 'categoryName',
      },
    };
  },
  methods: {
    //获取已设置分类
    async purchaseAreaCategory() {
      let params = {
        companyId: this.userInfo.companyId,
      };
      let res = await cmsOssApi.purchaseAreaCategory(params);

      if (res.data.categoryList) {
        this.hasPurchaseCategory = true;
        this.purchaseCategoryList = res.data.categoryList;
        this.$emit('getChildrenData', true);
      }
    },
    //模糊查询供应商列表
    async querySupplierList() {
      this.leftTableloading = true;
      let params = this.querySupplier;
      let res = await userApi.querySupplierList(params);
      this.leftTableloading = false;
      if (res.code == 200) {
        this.allSupplierList = res.data.records;
      }
    },
    leftSelectionChange(val) {
      this.leftMultipleSelection = val;
    },
    rightSelectionChange(val) {
      this.rightMultipleSelection = val;
    },

    async querySupplierListByPurchaserId(id) {
      this.rightTableloading = true;
      let params = {
        purchaserId: id,
      };
      let res = await productApi.querySupplierListByPurchaserId(params);
      this.rightTableloading = false;
      if (res.code == 200) {
        res.data.forEach((item) => {
          item.type = 1; //已选择
        });
        if (res.data && res.data.length > 0) {
          this.check1 = 2;
        }

        this.rightTableData = res.data;
        this.allRightTableData = JSON.stringify(this.rightTableData);
      }
    },

    //重置按钮
    reset(type) {
      if (type == 1) {
        this.querySupplier.companyName = '';
        this.querySupplierList();
      } else if (type == 2) {
        this.searchValue2 = '';
        let list = JSON.parse(this.allRightTableData);
        this.rightTableData = list;
      }
    },
    search(type) {
      if (type == 1) {
        this.querySupplierList();
      } else if (type == 2) {
        let arr = [];
        let list = JSON.parse(this.allRightTableData);
        list.forEach((item) => {
          if (item.supplierCompanyName.includes(this.searchValue2)) {
            arr.push(item);
          }
        });
        this.rightTableData = arr;
      }
    },
    //添加&取消
    transferTable(type) {
      if (type == 1) {
        this.leftMultipleSelection.forEach((item) => {
          let isOk = true;
          this.rightTableData.forEach((list) => {
            if (item.companyId == list.supplierCompanyId) {
              isOk = false;
            }
          });
          if (isOk) {
            this.rightTableData.push({
              supplierCompanyId: item.companyId,
              supplierCompanyName: item.companyName,
            });
          }
        });
        this.$refs.leftTableData.clearSelection();
      } else if (type == 2) {
        this.rightMultipleSelection.forEach((item) => {
          if (item.type == 1) {
            this.handleDelete(item.supplierCompanyId);
          }
          this.rightTableData.forEach((list, index) => {
            if (item.supplierCompanyId == list.supplierCompanyId) {
              this.rightTableData.splice(index, 1);
            }
          });
        });
      }
      this.allRightTableData = JSON.stringify(this.rightTableData);
    },

    async handleDelete(sid) {
      let params = {
        purchaserId: this.userInfo.companyId,
        supplierCompanyId: sid,
      };

      let res = await productApi.removePurchaseAreaCategory(params);
      console.log(res);
    },

    async selectCategory(row) {
      let params = {
        supplierCompanyId: row.supplierCompanyId,
      };
      this.purchaseInfo = row;
      let res = await productApi.queryCategoryBySupplierCompanyId(params);
      if (res.code == 200) {
        if (res.data.length > 0) {
          this.categoryList = res.data;
          this.dialogTitle = row.supplierCompanyName;
          this.categoryDialog = true;
          this.getSelectCategory(row.supplierCompanyId);
        } else {
          this.$message({
            message: '当前供应商下没有商品分类！',
            type: 'error',
          });
        }
      }
    },

    //获取已选择的供应商下小类
    async getSelectCategory(sid) {
      let params = {
        purchaserId: this.userInfo.companyId,
        supplierCompanyId: sid,
      };
      let res = await productApi.queryCategoryListBySupplierCompanyId(params);
      if (res.code == 200 && res.data.length > 0) {
        let arr = [];
        res.data.map((item) => {
          arr.push(item.categoryId);
        });
        this.selectedCategory = arr;
      }
    },

    async upDataCategory() {
      let params = {
        purchaserId: this.userInfo.companyId,
        supplierCompanyId: this.purchaseInfo.supplierCompanyId,
        supplierCompanyName: this.purchaseInfo.supplierCompanyName,
      };

      if (this.selectedCategory.length == 0) {
        this.$message({
          message: '请选择分类',
          type: 'error',
        });
        return;
      }
      let list = [];
      this.categoryList.forEach((item) => {
        if (this.selectedCategory.includes(item.categoryId)) {
          list.push(item);
        }
      });
      params.supplierCategoryList = list;
      this.dialogloading = true;
      let res = await productApi.addOrUpdatePurchaseAreaCategory(params);
      this.dialogloading = false;
      if (res.code == 200) {
        this.categoryDialog = false;
        this.$message({
          message: '添加分类成功！',
          type: 'success',
        });
        this.querySupplierListByPurchaserId(this.userInfo.companyId);
      }
    },

    async submitData() {
      let params = {
        purchaserId: this.userInfo.companyId,
      };
      this.reset(2);
      let isOk = true;
      this.rightTableData.map((item) => {
        if (!item.type) {
          isOk = false;
        }
      });
      if (!isOk) {
        this.$message({
          message: '请完善供应商分类信息！',
          type: 'error',
        });
        return;
      }
      let res = await productApi.generateCategoryTree(params);
      if (res.code == 200) {
        this.$message({
          message: '配置保存成功!',
          type: 'success',
        });
        this.purchaseAreaCategory();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import '@/assets/css/tip';
.exclusive-content {
  // .box-card-content{
  //   padding:0 10px;
  // }
  .upload-content {
    margin-top: 10px;
    width: 30%;
    .text {
      font-size: 12px;
      color: #666;
      line-height: 24px;
    }
    .upload {
      width: 80px;
      height: 30px;
      line-height: 30px;
      background: #2587ff;
      text-align: center;
      font-size: 14px;
      color: #fff;
    }
  }
  .my-treeTransfer {
    ::v-deep .component-transfer {
      .transfer-left {
        border-radius: 0;
      }
      .transfer-right {
        border-radius: 0;
      }
      .transfer-title {
        background-color: #fff;
        border-bottom: none;
        font-weight: normal;
        color: #333333;
        font-size: 14px;
        .el-checkbox {
          display: none;
        }
      }
      .transfer-center {
        .transfer-center-item {
          padding: 5px 10px 5px 10px;
        }
      }
    }
  }
}
</style>
